<script lang="ts" setup>
import AdvantageCard from '~/components/cards/AdvantageCard.vue'
import constants from '~/constants'
import Page from '~/enums/page'
import type { Advantage } from '~/types/advantages'
import type { BreadcrumbsItem } from '~/types/breadcrumbs'

const advantages: Advantage[] = [
  {
    description: 'Любыми электронными способами на\xA0сайте',
    iconName: 'outlined/credit-card',
    title: 'Оплата'
  },
  {
    description: 'По\xA0России и\xA0в\xA0страны СНГ курьером и\xA0в\xA0пункты выдачи',
    iconName: 'outlined/local-shipping',
    title: 'Доставка'
  },
  {
    description: 'Постоянные скидки и\xA0промоакции для вас и\xA0ваших друзей',
    iconName: 'outlined/gift-outline',
    title: 'Акции'
  },
  {
    description: 'Наши менеджеры всегда готовы ответить на\xA0ваши вопросы',
    iconName: 'filled/phone',
    title: 'На связи'
  }
]
const breadcrumbsItems: BreadcrumbsItem[] = [{ name: 'Главная', path: Page.Main }]
const title = 'О нас'

useHead({
  title: 'iTAB — онлайн-магазин по продаже экологичных товаров для здоровья',
  meta: [{
    name: 'description',
    content: 'Информация о компании iTAB. Онлайн-оплата на сайте. Доставка по РФ и СНГ. Постоянные акции и скидки. Служба поддержки.'
  }]
})
</script>

<template>
  <section>
    <div class="container">
      <Breadcrumbs :current="title" :items="breadcrumbsItems" />

      <h1>
        {{ title }}
      </h1>

      <div>
        <div class="row mb-4">
          <div
            v-for="(x, i) in advantages"
            :key="x.title"
            class="column-6 tb12 mb-2"
            :class="{ 'with-margin-bottom-16': i < advantages.length - 1 }"
          >
            <AdvantageCard :advantage="x" />
          </div>
        </div>
      </div>

      <div class="content-wrapper">
        <p>iTAB&nbsp;— онлайн-магазин по&nbsp;продаже нутрицевтиков и&nbsp;натуральных экологичных товаров для здоровья, молодости и&nbsp;красоты.</p>
        <p class="mb-10">
          Сегодня становятся востребованными саплименты и&nbsp;натуральные продукты для поддержки здоровья, молодости и&nbsp;красоты. Всё больше людей интересуются здоровым образом жизни и&nbsp;качественным питанием, опытные интегративные специалисты перешли с&nbsp;синтетических лекарственных препаратов на&nbsp;натуральные нутрицевтики, а&nbsp;спортсмены используют добавки для поддержания формы и&nbsp;улучшения продуктивности. Мы&nbsp;постоянно расширяем ассортимент продукции, ставшей незаменимой в&nbsp;жизни каждого человека, которому небезразлично собственное здоровье и&nbsp;здоровье близких.
        </p>

        <h2>При поддержке</h2>

        <div class="row mb-10">
          <div class="column-2 tb12 with-margin-bottom">
            <img
              alt="Владимир Евгеньевич Попов"
              class="w-full"
              loading="lazy"
              src="@/assets/img/vladimir-popov.jpg"
            >
          </div>
          <div class="column-4 tb12 with-margin-bottom">
            <p>Владимир Евгеньевич Попов (<a href="https://www.instagram.com/detsdoc/" target="_blank">@detsdoc</a>)&nbsp;— врач-невролог, нутрициолог, специалист интегративной медицины, руководитель международного проекта «Биохакинг. Эволюция внутри» (аудитория: 150&nbsp;тыс. человек).</p>
          </div>
          <div class="column-2 tb12 with-margin-bottom">
            <img alt="INMED" class="w-full" loading="lazy" src="@/assets/img/inmed-logo.svg">
          </div>
          <div class="column-4 tb12 with-margin-bottom">
            INMED&nbsp;— образовательная платформа и&nbsp;онлайн-сервис по&nbsp;поиску интегративных врачей и&nbsp;нутрициологов.
          </div>
        </div>

        <h2>Скидки</h2>

        <p class="mb-10">
          iTAB&nbsp;— это регулярные акции для покупателей и&nbsp;тех, кто хочет порекомендовать качественные нутрицевтики своим друзьям и&nbsp;подписчикам. <NuxtLink :to="Page.SpecialOffers">
            <span>Подробнее об&nbsp;акциях</span>
          </NuxtLink>.
        </p>

        <h2>Гарантия качества</h2>

        <p class="mb-10">
          iTAB ответственно подходит к&nbsp;выбору товаров и&nbsp;сотрудничает с&nbsp;поставщиками, гарантирующими качество продукции и&nbsp;имеющими необходимые сертификаты. Мы&nbsp;ценим мнение каждого клиента, поэтому если у&nbsp;вас есть жалобы, вопросы или предложения, вы&nbsp;всегда можете написать нам на&nbsp;адрес электронной почты: <a :href="`mailto:${constants.supportEmail}`">{{ constants.supportEmail }}</a>.
        </p>
        <p>С&nbsp;любовью и&nbsp;заботой о&nbsp;вашем здоровье, iTAB.</p>
      </div>
    </div>
  </section>
</template>
